<div class="tile">
  <div class="row mb-3">
    <div class="col-12">
      @if (model?.withCash) {
        <h5>{{ 'statistics.my-chart.headline.with-cash' | transloco }} {{ accountTotal + cashTotal | currency }}</h5>
      } @else {
        <h5>{{ 'statistics.my-chart.headline.default' | transloco }} {{ accountTotal | currency }}</h5>
      }
    </div>
  </div>
  @if (model?.periods) {
    <div class="row mb-3">
      <div class="col-12 col-md-6">
        <div class="nav nav-tabs mb-2 mt-0 no-select">
          @for (period of model.periods; track $index) {
            <div data-zid="my-chart-period" class="nav-item mr-1 mr-sm-3">
              <a
                class="nav-link cursor-pointer font-medium text-nowrap"
                [class.active]="period.isActive"
                (click)="togglePeriod(period.value)"
              >
                {{ period.label | transloco }}
              </a>
            </div>
          }
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="nav nav-tabs mb-2 mt-0 no-select justify-content-end">
          <div data-zid="my-chart-with-cash-toggle" class="nav-item mr-1 mr-sm-3">
            <a class="nav-link cursor-pointer font-medium text-nowrap" [class.active]="model.withCash" (click)="toggleCash(true)">
              {{ 'statistics.my-chart.cash-nav.with-cash' | transloco }}
            </a>
          </div>
          <div data-zid="my-chart-without-cash-toggle" class="nav-item mr-1 mr-sm-3">
            <a class="nav-link cursor-pointer font-medium text-nowrap" [class.active]="!model.withCash" (click)="toggleCash(false)">{{
              'statistics.my-chart.cash-nav.without-cash' | transloco
            }}</a>
          </div>
        </div>
      </div>
    </div>
  }

  <div class="row">
    <div class="col-12">
      @if (loading) {
        <div class="loading-indicator no-delay align-items-center justify-content-center row">
          <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      } @else if (!chartWithoutCash?.length || !chartWithCash?.length) {
        {{ 'statistics.my-chart.no-chart' | transloco }}
      }
      <div (window:resize)="onResize()" #chart class="chart-container" [class.active]="chartWithoutCash?.length"></div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="expand no-select" (click)="openModal()">
        <div class="mr-1 color-secondary">{{ 'statistics.weighting.expand' | transloco }}</div>
        <web-design-system-icon size="small" name="expand" color="action" />
      </div>
    </div>
  </div>
</div>
